import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { LicenseInfo } from '@mui/x-license';
import { store } from './app/store';

import App from './app/app';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

if (!process.env.NX_PUBLIC_MUI_LICENSE_KEY) {
  console.warn('⚠️ NX_PUBLIC_MUI_LICENSE_KEY is not set!');
}

if (!process.env.NX_PUBLIC_AUTH0_NAMESPACE) {
  console.warn('⚠️ NX_PUBLIC_AUTH0_NAMESPACE is not set!');
}

if (!process.env.NX_PUBLIC_APP_VERSION) {
  console.warn('⚠️ NX_PUBLIC_APP_VERSION is not set!');
}

if (!process.env.NX_PUBLIC_SITES_HOST) {
  console.warn('⚠️ NX_PUBLIC_SITES_HOST is not set!');
}

if (process.env.NX_PUBLIC_MUI_LICENSE_KEY) {
  LicenseInfo.setLicenseKey(process.env.NX_PUBLIC_MUI_LICENSE_KEY);
  console.log('✅ MUI License key set successfully');
} else {
  console.warn('⚠️ MUI License key not set - NX_PUBLIC_MUI_LICENSE_KEY is missing');
}

async function bootstrap() {
  // const { worker } = await import('./mocks/browser');
  // await worker.start({ onUnhandledRequest: 'bypass' });

  const root = createRoot(document.getElementById('root') as HTMLElement);

  root.render(
    <StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </StrictMode>,
  );
}

bootstrap();
